import { Link, useLocation } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import LowInventoryList from './Components/LowInventoryList/LowInventoryList';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchLowInventoryProducts } from '../../Features/reportAnalysisSlice';

function LowInventoryProductsPage() {
    const location = useLocation();
    const dispatch = useDispatch();

    // const lowInventoryProducts = useSelector((state) => state.reportAnalysis.lowInventoryProducts.lowInventoryProducts);

    useEffect(() => {
        dispatch(fetchLowInventoryProducts());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="w-full overflow-y-scroll pb-16">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="p-[10px] flex items-center justify-center">
                        <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-bold leading-8 text-[24px]">Low Inventory Products</h1>
                </div>
            </div>

            <LowInventoryList />
        </div>
    )
}

export default LowInventoryProductsPage;
